import { defineMessages } from 'react-intl';

export default defineMessages({
  customizedHeader: {
    id: 'ordering.includedSection.customizedHeader',
    defaultMessage: 'Customized recipe',
    description:
      'Heading when user has updated the default recipe for a product',
  },
  customizeLabel: {
    id: 'ordering.includedSection.customizeLabel',
    defaultMessage: 'Customize',
    description: 'The label for customize button',
  },
  defaultHeader: {
    id: 'ordering.includedSection.defaultHeader',
    defaultMessage: `What's included`,
    description: `Header for the What's Included section`,
  },
});
